import React, { useEffect } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import { useNavigate } from "react-router-dom";
import { IoMdArrowRoundBack } from "react-icons/io";
import { motion } from "framer-motion"; // Import Framer Motion
import "../../assets/styles/solutions.css";

const Solutions = () => {
  const navigate = useNavigate();
   useEffect(() => {
      window.scrollTo(0, 0);
    }, []);
  
  return (
    <div
      className="solutionss-container"
    
    >
      {/* Animated Back Button */}
      <motion.div transition={{ duration: 0.3 }}>
        <IoMdArrowRoundBack
          className="back-icon"
          onClick={() => navigate(-1)}
          style={{
            position: "absolute",
            top: "20px",
            left: "30px",
            fontSize: "2rem",
            color: "#B3FF00",
            cursor: "pointer",
          }}
        />
      </motion.div>

      {/* Animated Horizontal Line */}
      <motion.hr
        initial={{ scaleX: 0 }}
        animate={{ scaleX: 1 }}
        transition={{ duration: 1.5, ease: "easeInOut" }}
      />

      {/* Animated Headings & Paragraph */}
      <motion.h2
        className="solutionsTxt"
        initial={{ opacity: 0, y: 30 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 1.2, ease: "easeInOut" }}
      >
        Solutions
      </motion.h2>

      <motion.p
        className="solutionsPara"
        initial={{ opacity: 0, y: 30 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 1.2, ease: "easeInOut", delay: 0.2 }}
      >
        Expertise you can rely on. With a focus on the bigger picture, we
        provide the insights,<br /> guidance, and solutions that meet today’s
        needs while driving you toward your future<br /> goals.
      </motion.p>

      {/* Animated Business Verticals Section */}
      <motion.h2
        className="solutionsTxt"
        initial={{ opacity: 0, y: 30 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 1.2, ease: "easeInOut", delay: 0.4 }}
      >
        commceed business verticles
      </motion.h2>

      {/* Staggered List Items */}
      <motion.ul
        className="list-unstyled mt-3"
        initial="hidden"
        animate="visible"
        transition={{ staggerChildren: 0.2 }}
      >
        {[
          "Communications and Network Solutions",
          "Power Generation and Distribution",
          "Electrical and Lighting Systems",
          "Managed Services",
          "Security Solutions",
          "Automation Technologies",
          "MRO (Maintenance, Repair & Operations) and Safety",
          "Renewable Energy Solutions",
        ].map((item, index) => (
          <motion.li
            key={index}
            className="solutionsLi mb-2"
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 1.2, ease: "easeInOut", delay: 0.6 + index * 0.2 }}
          >
            {item}
          </motion.li>
        ))}
      </motion.ul>
    </div>
  );
};

export default Solutions;
